const notes = (state) => state.notes;
const note = (state) => state.note;

export default {
  notes,
  note,
};
